import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Header, Icon, Button, Tab, Loader } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import { ListStudent, StudentModal } from "../../../components/Admin/Student";
import { useAuth } from "../../../hooks";
import "./Student.scss";
import { Grade, AcademicCycle } from "../../../api";

const gradeController = new Grade();
const academicCycleController = new AcademicCycle();

export function Student() {
  const [reload, setReload] = useState(false);
  const [academicCycle, setAcademicCycle] = useState(null);
  const { accessToken } = useAuth();
  const { academicCycleId } = useParams();
  const [grades, setGrades] = useState([]);

  const [showModal, setShowModal] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onReload = () => setReload((prevState) => !prevState);

  useEffect(() => {
    (async () => {
      try {
        const response = await academicCycleController.getAcademicCycle(
          academicCycleId
        );
        setAcademicCycle(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [academicCycleId, accessToken]);

  /* useEffect(() => {
    (async () => {
      try {
        setGrades([]);
        const response = await gradeController.getGrades(accessToken);
        setGrades(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [academicCycleId, accessToken]); */

  //console.log("academicCycle.levelId", academicCycleId);
  
  useEffect(() => {
    if (!academicCycle) return;
    (async () => {
      try {
        setGrades([]);
        const response = await gradeController.getGradesByLevelId(
          academicCycle.levelId,
          accessToken
        );
        setGrades(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [academicCycle, accessToken]);
    
  const panes = [];

  for (const grade of grades) {
    panes.push({
      menuItem: grade.name,
      render: () => (
        <Tab.Pane as="div" attached={false}>
          <ListStudent
            gradeId={grade.id}
            academicCycle={academicCycle}
            reload={reload}
            onReload={onReload}
          />
        </Tab.Pane>
      ),
    });
  }

  if (!academicCycle) return <Loader active inline="centered" />;

  return (
    <>
      <div className="student-page">
        <Header as="h3">
          <Icon name="users" />
          <Header.Content>
            Estudiantes matriculados en Año académico {academicCycle.name} - {academicCycle.Level?.name}
          </Header.Content>
        </Header>
        <Button
          className="student-page__add"
          primary
          onClick={onOpenCloseModal}
          disabled={academicCycle.status === 3}
        >
          Matricular estudiante
        </Button>
        <Tab className="student-page__filters" menu={{ secondary: true }} panes={panes} />
      </div>
      <BasicModal
        size="large"
        title={`Matricular estudiante en Año académico ${academicCycle.name}`}
        show={showModal}
        close={onOpenCloseModal}
      >
        <StudentModal
          onClose={onOpenCloseModal}
          onReload={onReload}
          academicCycle={academicCycle}
          grades={grades}
        />
      </BasicModal>
    </>
  );
}
